import { useEffect, useState } from 'react';
import apiClient from '@utils/api-client';
import useTimeOffProcessor from '@hooks/processors/use-time-off-processor';
import { apiInternalTimeOffsPath } from '../../../routes';
const useGetTimeOffs = (queryParams) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();
    const { processTimeOff } = useTimeOffProcessor();
    useEffect(() => {
        if (queryParams === null) {
            setData([]);
            return;
        }
        const controller = new AbortController();
        setLoading(true);
        apiClient
            .get(apiInternalTimeOffsPath(), {
            params: queryParams,
            signal: controller.signal
        })
            .then((response) => {
            const result = response.data.data;
            const processedData = result.map((timeOff) => processTimeOff(timeOff));
            setData(processedData);
        })
            .catch((err) => {
            if (!controller.signal.aborted) {
                setData([]);
                setError(err);
            }
        })
            .finally(() => {
            if (!controller.signal.aborted) {
                setLoading(false);
            }
        });
        return () => {
            controller.abort();
        };
    }, [queryParams]);
    return { data, loading, error };
};
export default useGetTimeOffs;
